import React, {Component} from 'react';
import API from "../../services/API";
import NavBar from "../Common/NavBar";
import TopMenu from "../Common/TopMenu";

class Contents extends Component {
    state={
        content : ''
    }
    render() {
        return (
            <React.Fragment>
                <section className="container-fluid rtl ">
                    <div className="row">
                        <div className="col-md-3 px-2">
                            <NavBar />
                        </div>
                        <div className="col-md-9">
                            <TopMenu/>

                            <section className="container rtl mt-5">
                                <div className="row">
                                    <div className="col-12 p-5 mt-5 usual-content">
                                        <p  dangerouslySetInnerHTML={{ __html: this.state.content }}></p>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </section>
            </React.Fragment>

        );
    }
    componentDidMount = () => {
        API.usualContent(this.props.match.params.content)
            .then((response) => {
                const content = response.results.content;
                this.setState({content});
            })
    }

    componentDidUpdate = (prevProps, prevState) =>{
        if (prevProps.match.params.content !== this.props.match.params.content) {
            API.usualContent(this.props.match.params.content)
                .then((response) => {
                    const content = response.results.content;
                    this.setState({content});
                });
            var x = document.getElementsByClassName("main-nav")[0];

            if(window.screen.width < 500)
                     x.style.display="none";
        }
    }
}

export default Contents;